import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthFacade } from '@core/auth';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})

export class SignInGuard implements CanActivate {
  constructor(
    private authService: AuthFacade,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.authService.checkSession().pipe(
      map((isAuthenticated) => {
        if (isAuthenticated) {
          return this.router.createUrlTree(['/dashboard']);
        }

        return true;
      })
    );
  }
}
